import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api/axios";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { TENANT_AUTH } from '../authMode';
import TenantLogin from './TenantLogin';

export default function Login() {
  return TENANT_AUTH ? <TenantLogin /> : <LegacyLogin />;
}

function LegacyLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const destination = typeof location.state?.from === 'string' && location.state.from.startsWith('/sysadmin') ? location.state.from : '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/login", {
        password: password,
      });

      const token = response.data.token;
      localStorage.setItem("token", token);

      navigate(destination, { replace: true });
    } catch (err) {
      setError("Passwort falsch");
    }
  };

  return (
    <Paper elevation={2} sx={styles.container}>
      <Typography variant="h5" component="h2">Login</Typography>

      <Box component="form" onSubmit={handleSubmit} sx={styles.form}>
        <TextField
          type="password"
          placeholder="Passwort eingeben"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          size="small"
          fullWidth
        />

        <Button type="submit" variant="contained" startIcon={<LoginIcon />}>
          Einloggen
        </Button>
      </Box>

      {error && <Typography sx={styles.error}>{error}</Typography>}
    </Paper>
  );
}

const styles = {
  container: {
    maxWidth: 300,
    margin: "80px auto",
    padding: 2.5,
    border: "1px solid #ccc",
    borderRadius: "8px",
    textAlign: "center",
    backgroundColor: "background.paper",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  error: {
    color: "error.main",
    marginTop: 1.25,
  },
};
